import TrackingService from './service';
import {
  directorySortingTracker,
  filtersTracker,
  tagsTracker,
  directoryThumbnailTracker,
  segmentedDirectoryTracker,
} from './trackers/directory';
import { registrationOverlayTracker } from './trackers/registration';
import { authenticationTracker, userInfoTracker } from './trackers/user';
import { broadcasterPageNavigationTracker } from './trackers/broadcast';
import {
  friendsAndFavoritesMenuTracker,
  peekWindowTracker,
  consentScreenTracker,
  buyTokenOverlayTracker,
} from './trackers/interface';
import {
  domainTracker,
  routeTracker,
  adsInteractionTracker,
  modalsTracker,
} from './trackers/general';
import { ecommercePaymentTracker } from './trackers/ecommerce';


const trackingService = new TrackingService();
trackingService.register(adsInteractionTracker);
trackingService.register(authenticationTracker);
trackingService.register(broadcasterPageNavigationTracker);
trackingService.register(directorySortingTracker);
trackingService.register(directoryThumbnailTracker);
trackingService.register(domainTracker);
trackingService.register(filtersTracker);
trackingService.register(friendsAndFavoritesMenuTracker);
trackingService.register(peekWindowTracker);
trackingService.register(registrationOverlayTracker);
trackingService.register(routeTracker);
trackingService.register(tagsTracker);
trackingService.register(userInfoTracker);
trackingService.register(consentScreenTracker);
trackingService.register(buyTokenOverlayTracker);
trackingService.register(modalsTracker);
trackingService.register(segmentedDirectoryTracker);
trackingService.register(ecommercePaymentTracker);

export default trackingService;
